import { render, staticRenderFns } from "./onlineProduct.vue?vue&type=template&id=6d8afcc0&"
import script from "./onlineProduct.vue?vue&type=script&lang=js&"
export * from "./onlineProduct.vue?vue&type=script&lang=js&"
import style0 from "./onlineProduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports